import PropTypes from 'prop-types';
import React from 'react';

import Grid from '@glass/web/components/base/Unstable_Grid2';

import ContentList from '@glass/shared/components/Section/JobTitleContentExamplesSection/ContentList';
import Section from '@glass/shared/components/Section/Section';
import usePageTerms from '@glass/shared/modules/content/staticVariations/usePageTerms';
import resourceOrder from '@glass/shared/modules/resources/resourceOrder';

const ResumeExamplesSection = React.forwardRef(({ title, subtitle, type }, ref) => {
  const { jSlug, iSlug } = usePageTerms();

  if (!iSlug && !jSlug) {
    return null;
  }

  return (
    <Section ref={ref} subtitle={subtitle} title={title} type={type}>
      <Grid container spacing={1}>
        {resourceOrder.map((section) => (
          <Grid key={section} md={4} sm={6} xs={12}>
            <ContentList limitHeight section={section} />
          </Grid>
        ))}
      </Grid>
    </Section>
  );
});

ResumeExamplesSection.propTypes = {
  subtitle: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
};

ResumeExamplesSection.defaultProps = {
  title: '$(pageTerms.pageTerm) $(resumeWords.abbreviated) examples',
  subtitle: "We'll save these examples for when you're ready to get started",
};

export default React.memo(ResumeExamplesSection);
